export type LogLevel = "debug" | "info" | "warn" | "error";

/**
 * Generate RFC3339 timestamp (ISO 8601 format)
 * Returns format: YYYY-MM-DDTHH:MM:SS.sssZ
 */
export function generateRFC3339Timestamp(): string {
  return new Date().toISOString();
}

export type LogEntry<T> = {
  timestamp: string; // RFC3339 format
  session_id?: string; // Added in addToBatch
  index?: number; // Sequential auto-incrementing number, added in addToBatch
  package: string;
  level: LogLevel;
  message: string;
  errorStack?: string;
  payload?: T;
  context?: Record<string, unknown>;
};
